import {
  FlexRow,
  CFSTheading,
  ListCount,
  CFSTlistItem,
  ListLabel,
  FlexRowWithBorder,
  CustomCFSTheading,
  CustomCFSTlistItem,
  CustomSpan,
  CustomImg,
  Container,
  CustomErrBlock,
} from "../MetricDashboard.styles";
import PropTypes from "prop-types";
import { cfstConstants } from "./constants";
import styled from "styled-components";
import { CustomTooltip } from "../../../constants/common/StyledGlobalConstants";
import WarningIcon from "../../../assets/icons/warning-orange.svg";

const getBackgroundColor = (alertColor) => {
  if (alertColor > 100) return "#f85766";
  if (alertColor >= 50) return "#f09865ff";
  if (alertColor >= 25) return "#f9e070";
  return "#f6f6f6";
};

const CustomListItem = styled(CFSTlistItem)`
  width: ${(props) => (props.width ? "auto" : "15rem")};
  padding-right: ${(props) => (props.width ? "20px" : "0px")};
  background-color: ${(props) => getBackgroundColor(props.alertColor)};
  cursor: ${(props) => (props.alertColor >= 25 ? "pointer" : "default")};
`;

const getListCountColor = (alertColor) => {
  if (alertColor > 100) return "#f85766";
  if (alertColor >= 50) return "#f09865ff";
  if (alertColor >= 25) return "#f9e070";
  return "inherit";
};

const CustomListCount = styled(ListCount)`
  color: ${(props) => getListCountColor(props.alertColor)};
`;

const CountsView = ({
  heading = "",
  counts = [],
  notificationCounts = null,
  notificationDeRe = null,
  dashboardDeReData = {},
  showDeReCases = false,
  notification,
}) => {
  const renderCards = (countsData, startIndex, endIndex) =>
    countsData?.slice(startIndex, endIndex + 1).map((count) => {
      return <>{count?.percentage >= 25 ? renderTooltip(count, cardElement(count)) : cardElement(count)}</>;
    });

  const cardElement = (card) => (
    <CustomListItem key={card?.id} width={card?.value?.length > 10} alertColor={card.percentage}>
      <ListLabel title={card?.tooltip || ""}>{card?.name || ""}</ListLabel>
      <CustomListCount>{card?.value || 0}</CustomListCount>
    </CustomListItem>
  );

  const isOnlineSchedules = heading === cfstConstants.onlineSchedulesHeading;

  const renderNotification = () => {
    const notifications = isOnlineSchedules ? notification.onlineJobs : notification.offlineJobs;
    if (notifications.length) {
      return (
        <ul
          style={{
            background: "#FFECE0",
            margin: "1rem 1rem 0rem 2rem",
            padding: "1rem 0rem 1rem 2rem",
            fontSize: "1rem",
          }}
        >
          {notifications?.map((msg, index) => {
            const keyIndexValue = `notification-${index}`;
            return (
              <li key={keyIndexValue} style={{ height: "1.7rem" }}>
                {msg}
              </li>
            );
          })}
        </ul>
      );
    }
  };

  const renderTooltip = (card, node) => (
    <CustomTooltip marginLeft="8px" renderAnchorElement={() => node} key={`tooltip-${card?.id ?? "100"}`}>
      {card.tooltip}
    </CustomTooltip>
  );

  const renderDeReCasesCard = () => {
    const deReCaseCard = (
      <CustomCFSTlistItem alertColor={dashboardDeReData?.percentage}>
        <ListLabel>De/Re Cases</ListLabel>
        {notificationDeRe ? <ListCount>--</ListCount> : <CustomListCount>{dashboardDeReData?.caseCount}</CustomListCount>}
      </CustomCFSTlistItem>
    );
    return dashboardDeReData.percentage >= 25 ? renderTooltip(dashboardDeReData, deReCaseCard) : deReCaseCard;
  };

  return (
    <>
      <CFSTheading>{heading}</CFSTheading>
      {notificationCounts && (
        <CustomErrBlock>
          <CustomImg src={WarningIcon} alt="warning" />
          Unable to fetch the job counts
        </CustomErrBlock>
      )}
      {renderNotification()}
      <FlexRow>{renderCards(counts, 0, 4)}</FlexRow>
      <FlexRowWithBorder>
        <Container>
          <CustomCFSTheading>Schedule Classification</CustomCFSTheading>
          <div>
            <FlexRow>{renderCards(counts, 5, 9)}</FlexRow>
            <FlexRow>{renderCards(counts, 10, isOnlineSchedules ? 13 : 10)}</FlexRow>
          </div>
        </Container>
      </FlexRowWithBorder>
      {showDeReCases && (
        <FlexRow>
          {notificationDeRe && (
            <CustomSpan>
              <CustomImg src={WarningIcon} alt="warning" />
              Unable to fetch the DeRe case counts
            </CustomSpan>
          )}
          <CustomCFSTlistItem>
            <ListLabel>Total CFST Cases</ListLabel>
            {notificationDeRe ? <ListCount>--</ListCount> : <CustomListCount>{dashboardDeReData?.totalCfstCaseCount}</CustomListCount>}
          </CustomCFSTlistItem>
          {renderDeReCasesCard()}
        </FlexRow>
      )}
    </>
  );
};

CountsView.propTypes = {
  heading: PropTypes.string,
  counts: PropTypes.array,
  notificationCounts: PropTypes.node,
  notificationDeRe: PropTypes.node,
  dashboardDeReData: PropTypes.object,
  showDeReCases: PropTypes.bool,
  notification: PropTypes.object,
};

export default CountsView;
